<script>
import appConfig from "@/app.config";
import Layout from "@/router/layouts/main";

export default {
  name: "Default",
  components: {
    Layout,
  },
  page: {
    title: "",
    meta: [{ name: "description", content: appConfig.description }],
  },
  props: {
    size: { type: Number, default: 20 },
    gap: { type: Number, default: 10 },
    speed: { type: Number, default: 0.6 },
  },
  computed: {
    wrapperStyle() {
      return {
        "--gap": `${this.gap}px`,
      };
    },
  }
};
</script>
<template>
  <Layout>
    <div id="app-loader">
      <div class="dots" :style="wrapperStyle">
        <span v-for="i in 5" :key="i" class="dot" :style="dotStyle(i)"></span>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
#app-loader {
  position: fixed;
  inset: 0;
  z-index: 9999;

  display: flex;
  align-items: center;
  justify-content: center;

  /* limpio, sin blur */
  background: rgba(255, 255, 255, 0.3);
}

/* contenedor */
.dots {
  display: flex;
  gap: var(--gap);
}

/* cada punto */
.dot {
  border-radius: 50%;
  opacity: 0.3;

  animation-name: bounce;
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
}

/* animación tipo wave */
@keyframes bounce {
  0%, 80%, 100% {
    transform: scale(0.6);
    opacity: 0.3;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}
</style>